import React from "react";
import { Container } from "./styles";
import Title from "../Title";
import usePlaylistsAndAlbums from "../../utils/usePlaylistsAndAlbums";

const PlaylistAndSessions = ({ isDesktop }) => {
  const { albums, playlists } = usePlaylistsAndAlbums();
  // const allAlbums = isDesktop ? albums : albums.slice(0, 6);

  return (
    <Container>
      <div className="playlist">
        <Title
          title={"Playlists"}
          subTitle={"See all playlists"}
          onSubtitleClick={() => {
            window.location = `${process.env.GATSBY_BLUE_DOT_APP_URL}/playlists`;
          }}
        />
        <div className="playlists">
          {playlists.length > 0 &&
            playlists.map((item, index) => {
              return (
                <div
                  key={index}
                  role="button"
                  className="playlist-card"
                  onClick={() => {
                    window.location = `${process.env.GATSBY_BLUE_DOT_APP_URL}/playlist/${item.id}`;
                  }}
                  onKeyDown={() => {
                    window.location = `${process.env.GATSBY_BLUE_DOT_APP_URL}/playlist/${item.id}`;
                  }}
                  tabIndex={0}
                >
                  <img
                    className="playlist-img"
                    src={`${process.env.GATSBY_FILES_URL}${item.thumbnail}`}
                    alt="album-thumbnail"
                  />
                  <div className="right-content">
                    <h3 className="playlist-title">{item.name}</h3>
                    <p className="playlist-description">
                      {item?.description.length > 100
                        ? `${item.description.slice(0, 100)}...`
                        : item.description}
                    </p>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="sessions">
        <Title title={"Recent Sessions"} />
        <div className="sessions-list">
          {albums.length > 0 &&
            albums.map((album, index) => (
              <a
                key={index}
                href={`${process.env.GATSBY_BLUE_DOT_APP_URL}/album/${album.id}`}
                className="playlist-img"
                style={{ textDecoration: "none" }}
              >
                <img
                  src={`${process.env.GATSBY_FILES_URL}${album.thumbnail}`}
                  alt="album-thumbnail"
                  style={{ width: 123, height: 123 }}
                />
              </a>
            ))}
        </div>
      </div>
    </Container>
  );
};

export default PlaylistAndSessions;
